import React from 'react';
import MenuIcon from '@mui/icons-material/Menu';

const TemplateMobileRailTrigger = ({
    isMobileTemplateDetailsLayout,
    setIsMobileDetailsRailOpen,
}) => (
    isMobileTemplateDetailsLayout ? (
        <div className="details-mobile-rail-trigger-row">
            <button
                type="button"
                className="details-mobile-rail-trigger"
                onClick={() => setIsMobileDetailsRailOpen(true)}
                aria-label="Open tabs"
            >
                <MenuIcon fontSize="small" />
            </button>
        </div>
    ) : null
);

export default TemplateMobileRailTrigger;
